import React from 'react';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from 'material-ui/Dialog';
import Grid from 'material-ui/Grid';
import Button from 'material-ui/Button';
import Typography from 'material-ui/Typography';
import styles from './style.scss';

const ModalContainer = props => {
  return (
    <Dialog
      open={props.showModal}
      maxWidth={'md'}
      onRequestClose={props.disableClose ? null : props.hideModal}
      classes={{paperWidthMd: styles['dialog-lg']}}
    >
      <DialogTitle disableTypography={true} style={{display: 'flex', justifyContent: 'space-between'}}>
        <Typography type="title" style={{lineHeight: '33px'}}>
          {props.title}
        </Typography>
        {props.disableClose ? null : <Button onClick={props.hideModal}>Close</Button>}
      </DialogTitle>
      <DialogContent>
        {props.children}
      </DialogContent>
    </Dialog>
  )
}

ModalContainer.defaultProps = {
  showModal: false,
  hideModal: () => {},
  title: '',
}

export default ModalContainer;


// WEBPACK FOOTER //
// ./routes/Modal/container/index.jsx